import * as cmmn from '@utils/index';
import {logger} from "@services/logger/logger.service";
import {environment} from "@env";
import { BaseHost } from "@core/shared/office-hosts/base-host";
import { IOfficeHost } from "@core/shared/office-hosts/office-host.types";

export class WordHost extends BaseHost implements IOfficeHost
{
    public override async getDocumentIDAsync(): Promise<string>
    {
        const fileUrlID = await this.resolveFileUrlDocumentIDAsync();
        if (fileUrlID)
        {
            return fileUrlID;
        }

        return (await this.resolveSettingsDocumentIDAsync()) ?? '';
    }

    public override checkSelectable() { return true; }
    public override checkEditable(): boolean { return true; }
    public override checkDocumentReadable(): boolean {return true;}

    public override getTag(): string {
        return 'word';
    }

    public override async setSelectedTextAsync(plainText: string): Promise<void> {
        await Word.run(function (context) {
            const selection = context.document.getSelection();

            selection.insertText(plainText, Word.InsertLocation.start);

            return context.sync()
        });
    }

    public override async setSelectedFormattedTextAsync(plainText: string, html: string): Promise<void> {
        await Word.run(function (context) {
            const selection = context.document.getSelection();

            selection.insertHtml(html, Word.InsertLocation.start);

            return context.sync()
        });
    }

    public override async setSelectedImageAsync(fileName: string, b64Text: string): Promise<void> {
        await Word.run(function (context) {
            const selection = context.document.getSelection();

            selection.insertInlinePictureFromBase64(b64Text, Word.InsertLocation.start);

            return context.sync()
        });
    }

    public override async getSelectedContentAsync(): Promise<string> {
        let resultStr = '';

        const resultValue = await cmmn.callAsync<boolean>(async (r) => {
            try {
                Office.context.document.getSelectedDataAsync<string>(Office.CoercionType.Text, (asyncResult) => {
                    if (asyncResult.status == Office.AsyncResultStatus.Failed) {
                        logger.error(this, `getSelectedContentAsync() > failed: ${asyncResult.error.message}`);
                        r.next(false);
                    }
                    else {
                        resultStr = asyncResult.value;
                        r.next(true);
                    }
                });
            }
            catch (err) {
                r.next(false);
            }
        });

        if (resultValue) {
            return resultStr;
        }

        return '';
    }

    public override async getDocumentTextAsync(): Promise<string> {
        let docText = '';

        const resultValue = await cmmn.callAsync<boolean>(async (r) => {
            try {
                Office.context.document.getFileAsync(Office.FileType.Text,
                    { sliceSize: environment.limits_bytes.WHOLE_MESSAGE },
                    (asyncResult) => {
                        if (asyncResult.status == Office.AsyncResultStatus.Failed) {
                            logger.error(this, `getFileAsync() > failed: ${asyncResult.error.message}`);
                            return r.next(false);
                        }

                        const docFile = <Office.File>asyncResult.value;
                        docFile.getSliceAsync(0, (sliceResult) => {
                            if (sliceResult.status == Office.AsyncResultStatus.Failed) {
                                logger.error(this, `getSliceAsync() > failed: ${asyncResult.error.message}`);
                                return r.next(false);
                            }

                            docText = <string>sliceResult.value.data;

                            docFile.closeAsync((closeResult) => {
                                if (closeResult.status == Office.AsyncResultStatus.Failed) {
                                    logger.error(this, `closeAsync() > failed: ${asyncResult.error.message}`);
                                    return r.next(false);
                                }
                            })

                            r.next(true);
                        })
                });
            }
            catch (err) {
                r.next(false);
            }
        });

        if (resultValue) {
            return docText;
        }

        return '';
    }
}
